import React, { forwardRef, useId } from 'react';
import styles from './Input.module.css';

const Input = forwardRef(function Input(
  { label, hint, error, iconLeft, iconRight, className = '', id, ...rest },
  ref
) {
  const generatedId = useId();
  const inputId = id || generatedId;

  return (
    <div className={[styles.field, error ? styles.hasError : '', className].filter(Boolean).join(' ')}>
      {label ? (
        <label className={styles.label} htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <div className={styles.inputWrap}>
        {iconLeft ? <span className={styles.iconLeft}>{iconLeft}</span> : null}
        <input ref={ref} id={inputId} className={styles.input} {...rest} />
        {iconRight ? <span className={styles.iconRight}>{iconRight}</span> : null}
      </div>
      {error ? <p className={styles.error}>{error}</p> : hint ? <p className={styles.hint}>{hint}</p> : null}
    </div>
  );
});

export default Input;
